import {
  FormHelperText,
  IconButton,
  TextField,
  Typography,
} from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import TableRow from "@material-ui/core/TableRow";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { DatePicker } from "@material-ui/pickers";
import { useTheme } from "@material-ui/styles";
import AddRowButton from "components/common/AddRowButton";
import {
  Bagde,
  StyledTableCell,
  TableRowHead,
  UploadButton,
  useStyles,
} from "components/request-document/components/Commons";
import SelectCountryDialog from "components/request-document/components/SelectCountryDialog";
import { openFileById } from "libs/utils/file";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash-es";
import React from "react";
import { useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectMasterData } from "redux/modules/masterSlice";
import FileService from "services/FileService";

export default function WorkExperienceSection({
  formik,
  defaultWorkExperience,
  bagde = 20,
}) {
  const classes = useStyles();
  const theme = useTheme();
  const masterData = useSelector(selectMasterData);
  const countryConfig = get(masterData, "countryConfig", []);

  const WorkExperience = formik.values.WorkExperience;
  const canEdit = useSelector(canEditForm);
  return (
    <>
      <TableRow>
        <StyledTableCell colSpan={6}>
          <div className={classes.cellContent}>
            <Bagde number={bagde} />
            <div className={classes.wrapField}>
              <Typography variant="h6" className={classes.title}>
                Work experience (past 10 years)
              </Typography>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRowHead>
        <StyledTableCell>
          <div className={classes.cellContent}>
            {/* <Bagde number={0} /> */}
            <div className={classes.wrapField}>
              <InputLabel>Period</InputLabel>
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell>
          <InputLabel>Name of organization</InputLabel>
        </StyledTableCell>
        <StyledTableCell>
          <InputLabel>City / Country</InputLabel>
        </StyledTableCell>
        <StyledTableCell>
          <InputLabel>Responsibility</InputLabel>
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <InputLabel>File upload</InputLabel>
        </StyledTableCell>
      </TableRowHead>
      {WorkExperience.map((experience, index) => {
        if (!experience.Status) return null;
        return (
          <TableRow key={experience.workId + "-" + index}>
            <StyledTableCell>
              <div
                style={{ width: 200, display: "flex", flexDirection: "row" }}
              >
                <DatePicker
                  disabled={!canEdit}
                  // className={classes.formControl}
                  style={{ minWidth: 100, width: 100 }}
                  inputVariant="outlined"
                  disableFuture={false}
                  openTo="year"
                  format="DD-MM-YYYY"
                  label="Start date"
                  views={["year", "month", "date"]}
                  name={`WorkExperience[${index}].PreiodFrom`}
                  value={
                    formik.values.WorkExperience[index]?.PreiodFrom || null
                  }
                  onChange={(date) => {
                    formik.setFieldValue(
                      `WorkExperience[${index}].PreiodFrom`,
                      date.format("YYYY-MM-DD")
                    );
                  }}
                  error={isError(`WorkExperience[${index}].PreiodFrom`, formik)}
                  helperText={getErrorMessage(
                    `WorkExperience[${index}].PreiodFrom`,
                    formik
                  )}
                />
                <DatePicker
                  disabled={!canEdit}
                  // className={classes.formControl}
                  style={{ minWidth: 100, width: 100, marginLeft: 8 }}
                  inputVariant="outlined"
                  // disableFuture={false}
                  openTo="year"
                  format="DD-MM-YYYY"
                  label="End date"
                  views={["year", "month", "date"]}
                  name={`WorkExperience[${index}].PreiodTo`}
                  value={formik.values.WorkExperience[index]?.PreiodTo || null}
                  onChange={(date) => {
                    formik.setFieldValue(
                      `WorkExperience[${index}].PreiodTo`,
                      date.format("YYYY-MM-DD")
                    );
                  }}
                  error={isError(`WorkExperience[${index}].PreiodTo`, formik)}
                  helperText={getErrorMessage(
                    `WorkExperience[${index}].PreiodTo`,
                    formik
                  )}
                />
              </div>
            </StyledTableCell>
            <StyledTableCell>
              <TextField
                disabled={!canEdit}
                className={classes.textField}
                style={{ width: 150 }}
                variant="outlined"
                name={`WorkExperience[${index}].WorkOrganization`}
                value={formik.values.WorkExperience[index]?.WorkOrganization}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError(
                  `WorkExperience[${index}].WorkOrganization`,
                  formik
                )}
                helperText={getErrorMessage(
                  `WorkExperience[${index}].WorkOrganization`,
                  formik
                )}
              />
            </StyledTableCell>
            <StyledTableCell>
              <div style={{ width: 100 }}>
                <SelectCountryDialog
                  disabled={!canEdit}
                  formik={formik}
                  countryFieldName={`WorkExperience.${index}.countryId`}
                  cityFieldName={`WorkExperience.${index}.WorkCity`}
                />
              </div>
            </StyledTableCell>
            <StyledTableCell>
              <div className={classes.flexRow}>
                <TextField
                  disabled={!canEdit}
                  className={classes.textField}
                  variant="outlined"
                  name={`WorkExperience[${index}].WorkResponsibility`}
                  value={
                    formik.values.WorkExperience[index]?.WorkResponsibility
                  }
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError(
                    `WorkExperience[${index}].WorkResponsibility`,
                    formik
                  )}
                  helperText={getErrorMessage(
                    `WorkExperience[${index}].WorkResponsibility`,
                    formik
                  )}
                />
              </div>
            </StyledTableCell>
            <StyledTableCell align="center">
              <div
                style={{
                  width: 105,
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <UploadButton
                  disabled={!canEdit}
                  title={
                    get(formik.values, `WorkExperience[${index}].FileID`, "")
                      ? "Edit"
                      : "+ Add"
                  }
                  id={`upload-${index}`}
                  onChange={async (event) => {
                    try {
                      const response = await FileService.uploadFile({
                        file: event.target.files[0],
                        Status: true,
                      });

                      const fileId = response.results?.fileID;
                      const [filename, ext] =
                        event.target.files[0].name.split(".");

                      formik.setFieldValue(
                        `WorkExperience[${index}].FileID`,
                        fileId
                      );
                      formik.setFieldValue(
                        `WorkExperience[${index}].filename`,
                        filename
                      );
                      formik.setFieldValue(
                        `WorkExperience[${index}].ext`,
                        `.${ext}`
                      );
                    } catch (error) {
                      console.log("Upload error", error);
                    }
                  }}
                />
                {get(formik.values, `WorkExperience[${index}].FileID`, "") && (
                  <IconButton
                    disabled={!canEdit}
                    style={{ width: 40 }}
                    size="small"
                    onClick={async () => {
                      const fileId = get(
                        formik.values,
                        `WorkExperience[${index}].FileID`,
                        ""
                      );
                      openFileById(fileId);
                    }}
                  >
                    <VisibilityIcon />
                  </IconButton>
                )}
              </div>

              <FormHelperText
                error={isError(`WorkExperience[${index}].FileID`, formik)}
              >
                {getErrorMessage(`WorkExperience[${index}].FileID`, formik)}
              </FormHelperText>
            </StyledTableCell>
            <StyledTableCell align="center">
              {index === 0 ? (
                <div style={{ width: 40 }} />
              ) : (
                <React.Fragment>
                  <IconButton
                    disabled={!canEdit}
                    style={{ width: 40, color: theme.palette.error.main }}
                    size="small"
                    onClick={async () => {
                      if (experience.workId) {
                        formik.setFieldValue(
                          `WorkExperience[${index}].Status`,
                          false
                        );
                      } else {
                        formik.setFieldValue(
                          "WorkExperience",
                          WorkExperience.filter((__, i) => i !== index)
                        );
                      }
                    }}
                  >
                    <DeleteForeverIcon />
                  </IconButton>
                  <FormHelperText error={false}> </FormHelperText>
                </React.Fragment>
              )}
            </StyledTableCell>
          </TableRow>
        );
      })}
      <TableRow>
        <StyledTableCell colSpan={6}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <AddRowButton
              disabled={!canEdit}
              onClick={() => {
                formik.setFieldValue("WorkExperience", [
                  ...WorkExperience,
                  defaultWorkExperience,
                ]);
              }}
            />
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
}
